import lodash from "lodash";
import { POLL_TYPE } from "./../ricos-content/index.js";
import { biStrategy } from "./biStrategy/biStrategy.js";
import iframeSandboxDomainStrategy from "./iframeSandboxDomainStrategy/iframeSandboxDomainStrategy.js";
import pollsStrategy from "./pollsStrategy/pollsStrategy.js";
import {
  hasPlugin as hasPluginInPlugins,
  hasPollsPluginInContent,
  parseInstance
} from "./services/index.js";
import urlResolutionStrategy from "./urlResolutionStrategy/urlResolutionStrategy.js";
const runStrategies = ({
  experiments = {},
  plugins,
  instance,
  wixRicosVersion,
  ricosVersion,
  biSettings,
  getWixClientPromise,
  msid = "",
  viewer = false,
  content
}) => {
  const hasPlugin = (pluginType) => hasPluginInPlugins(pluginType, plugins);
  const { metaSiteId: instanceMsid, appDefId } = parseInstance(instance);
  const metaSiteId = instanceMsid || msid;
  const { ricosFeatures, wixRicosFeatures } = experiments;
  const shouldUsePollStrategy = hasPlugin(POLL_TYPE) && (!viewer || viewer && hasPollsPluginInContent(content));
  return lodash.merge(
    { experiments: ricosFeatures },
    biStrategy(appDefId, metaSiteId, wixRicosVersion, ricosVersion, biSettings, wixRicosFeatures),
    urlResolutionStrategy(hasPlugin, instance, metaSiteId, wixRicosFeatures),
    shouldUsePollStrategy && pollsStrategy(instance, getWixClientPromise),
    iframeSandboxDomainStrategy(metaSiteId),
    wixRicosFeatures
  );
};
const runStrategiesWithCommonUtils = (props) => ({
  strategies: runStrategies(props)
});
export {
  runStrategies,
  runStrategiesWithCommonUtils
};
//# sourceMappingURL=runStrategies.js.map
